import {cancellationReasonsDriveOff, cancellationReasonsParking, closeReasons, colors, ticketLegalStatus, ticketStatus, ticketUserStatus} from "../globals";


export const switchLegalStatus = (t, param) => {
    switch (param) {
      case ticketLegalStatus.NONE:
        return (
          <div>
            <span>{t("Violations.LegalStatus.NONE")}</span>
          </div>
        );
      case ticketLegalStatus.REMINDED:
        return (
          <div>
            <span style={{ color: "orange" }}>
              {t("Violations.LegalStatus.REMINDED")}
            </span>
          </div>
        );
      case ticketLegalStatus.SUED:
        return (
          <div>
            <span style={{ color: "red" }}>
              {t("Violations.LegalStatus.SUED")}
            </span>
          </div>
        );
      case ticketLegalStatus.TERMINATED:
        return (
          <div>
            <span style={{ color: "green" }}>
              {t("Violations.LegalStatus.TERMINATED")}
            </span>
          </div>
        );
      case ticketLegalStatus.INVOICE_SENT:
        return (
          <div>
            <span style={{ color: "purple" }}>
              {t("Violations.LegalStatus.INVOICE_SENT")}
            </span>
          </div>
        );

      case ticketLegalStatus.OPERATION_DOC_SENT:
        return (
          <div>
            <span style={{ color: "blue" }}>
              {t("Violations.LegalStatus.OPERATION_DOC_SENT")}
            </span>
          </div>
        );
      case ticketLegalStatus.TO_SUE:
        return (
          <div>
            <span style={{ color: "black" }}>
              {t("Violations.LegalStatus.TO_SUE")}
            </span>
          </div>
        );
      case ticketLegalStatus.TO_BE_ENFORCED:
        return (
          <div>
            <span style={{ color: "black" }}>
              {t("Violations.LegalStatus.TO_BE_ENFORCED")}
            </span>
          </div>
        );
      case ticketLegalStatus.PENALTY_FEE_DEMANDED:
        return (
          <div>
            <span style={{ color: "black" }}>
              {t("Violations.LegalStatus.PENALTY_FEE_DEMANDED")}
            </span>
          </div>
        );
      case ticketLegalStatus.LAST_REMINDER:
      return (
        <div>
          <span style={{ color: "black" }}>
            {t("Violations.LegalStatus.LAST_REMINDER")}
          </span>
        </div>
      );


      default:
        return "";
    }
  };

export const switchStatus = (t, row) => {
  if (row?.status == null) {
    return null;
  }
  switch (row.status) {
    case ticketStatus.ISSUED:
      return (
        <div>
          <span style={{ color: "orange" }}>
            {t("Violations.Status.ISSUED")}
          </span>
        </div>
      );
    case ticketStatus.PAID:
      return (
        <div style={{ color: "green" }}>{t("Violations.Status.PAID")}</div>
      );
    case ticketStatus.STOPPED:
      return (
        <div style={{ color: "orange" }}>{t("Violations.Status.STOPPED")}</div>
      );
      case ticketStatus.WAIT:
        return (
          <div style={{ color: "black" }}>{t("Violations.Status.WAIT")}</div>
        );
      case ticketStatus.PARKING_GRACE:
        return (
          <div style={{ color: "black" }}>{t("Violations.Status.PARKING_GRACE")}</div>
        );
    case ticketStatus.OVERDUE:
      return (
        <div style={{ color: "red" }}>{t("Violations.Status.OVERDUE")}</div>
      );
    case ticketStatus.DOWNPAID:
      return (
        <div>
          <span
            style={row.reminderDeadline ? { color: "red" } : { color: "grey" }}
          >
            {t("Violations.Status.DOWNPAID")}
          </span>
        </div>
      );
    case ticketStatus.CHECK:
      return (
        <div>
          <span style={{ color: "black" }}>{t("Violations.Status.CHECK")}</span>
        </div>
      );
    case ticketStatus.DONE:
      return (
        <div>
          <span style={{ color: "gray" }}>
            {t("Violations.Status.COMPLITED")}
          </span>
        </div>
      );
    case ticketStatus.PENDING:
      return (
        <div>
          <span style={{ color: "blue" }}>
            {t("Violations.Status.PENDING")}
          </span>
        </div>
      );
    case ticketStatus.PENDING_ACTIVATION:
      return (
        <div>
          <span style={{ color: "blue" }}>
            {t("Violations.Status.PENDING_ACTIVATION")}
          </span>
        </div>
      );
    case ticketStatus.GRACE:
      return (
        <div style={{ color: "black" }}>{t("Violations.Status.GRACE")}</div>
      );
    default:
      return "";
  }
};

export const switchUserStatus = (t, row) => {
  switch (row.userStatus) {
    case ticketUserStatus.OPEN:
      return (
        <div>
          <span style={{ color: colors.blue }}>
            {t("Violations.UserStatus.OPEN")}
          </span>
        </div>
      );
    case ticketUserStatus.PAID:
      return (
        <div style={{ color: colors.green }}>{t("Violations.UserStatus.PAID")}</div>
      );
    case ticketUserStatus.CANCELLED:
      return (
        <div style={{ color: colors.red }}>{t("Violations.UserStatus.CANCELLED")}</div>
      );
    case ticketUserStatus.CLOSED:
      return (
        <div>
          <span style={{ color: colors.gray }}>
            {t("Violations.UserStatus.CLOSED")}
          </span>
        </div>
      );
    default:
      return "";
  }
};

export const switchStatusInformation = (t, row) => {
  if(row.status === ticketStatus.DOWNPAID && row.legalStatus === ticketLegalStatus.TERMINATED) {
    return (
      <div style={{ color: colors.gray }}>
          {t("CloseReasons.NO_FOLLOW_UP")}
      </div>
    );
  }
  
  if((row.cancellationReason !== null && row.cancellationReason !== undefined) && 
  (row.status == ticketStatus.STOPPED || row.status == ticketStatus.DONE)) {
    switch (row.cancellationReason) {
      case "CASHIERS_MISTAKE":
      case cancellationReasonsDriveOff.CASHIERS_MISTAKE:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.CASHIERS_MISTAKE")}
          </div>
        );  
      case "PAYMENT_TERMINAL_DEFECTIVE":
      case cancellationReasonsDriveOff.PAYMENT_TERMINAL_DEFECTIVE:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.PAYMENT_TERMINAL_DEFECTIVE")}
          </div>
        );
      case "GOODWILL":
      case cancellationReasonsDriveOff.GOODWILL:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.GOODWILL")}
          </div>
        );
      case "INPUT_ERROR":
      case cancellationReasonsDriveOff.INPUT_ERROR:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.INPUT_ERROR")}
          </div>
        );
      case "GOODWILL_BEPPO":
      case cancellationReasonsDriveOff.GOODWILL_BEPPO:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.GOODWILL_BEPPO")}
          </div>
        );
      case "POOR_IMAGE_QUALITY":
      case cancellationReasonsDriveOff.POOR_IMAGE_QUALITY:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.POOR_IMAGE_QUALITY")}
          </div>
        );
      case "CUSTOMER_PAID_AT_GAS_STATION":
      case cancellationReasonsDriveOff.CUSTOMER_PAID_AT_GAS_STATION:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.CUSTOMER_PAID_AT_GAS_STATION")}
          </div>
        );
      case "PARKING_PERMISSION_GRANTED":
      case cancellationReasonsParking.PARKING_PERMISSION_GRANTED:
        return (
          <div style={{ color: colors.red }}>
              {t("CancellationReasons.PARKING_PERMISSION_GRANTED")}
          </div>
        );
      default:
        return (
          <div>
              {row.cancellationReason}
          </div>
        );
    }
  }
  
  if(row.closeReason !== null && row.closeReason !== undefined) {
    switch (row.closeReason) {
      case "NO_FOLLOW_UP":
      case closeReasons.NO_FOLLOW_UP:
        return (
          <div style={{ color: colors.gray }}>
              {t("CloseReasons.NO_FOLLOW_UP")}
          </div>
        );
      case "INSUFFICIENT_EVIDENCE":
      case closeReasons.INSUFFICIENT_EVIDENCE:
        return (
          <div style={{ color: colors.gray }}>
              {t("CloseReasons.INSUFFICIENT_EVIDENCE")}
          </div>
        );  
      case "REPORTED_TO_POLICE":
      case closeReasons.REPORTED_TO_POLICE:
        return (
          <div style={{ color: colors.gray }}>
              {t("CloseReasons.REPORTED_TO_POLICE")}
          </div>
        );
      default:
        return (
          <div>
              {row.closeReason}
          </div>
        );
    }
  }

  return "";
};
